var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18C15.2549 17.1252 16.9944 16.2584 18.75 15.3832C16.9892 14.4998 15.2501 13.628 13.5 12.75C13.5 14.5061 13.5 16.2442 13.5 18Z",
    fill: "#D9DDDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71601 0 0 6.7157 0 15C0 23.2843 6.71601 30 15 30C23.284 30 30 23.2843 30 15C30 6.7157 23.284 0 15 0Z",
    fill: "#079D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2943 8.63621C14.2943 8.28484 14.6103 8 15 8C15.3897 8 15.7057 8.28484 15.7057 8.63621V14.0789L17.9197 12.0813C18.1954 11.8327 18.6425 11.8327 18.9182 12.0813C19.1939 12.3299 19.1939 12.7329 18.9182 12.9815L15.4957 16.0639L15.4834 16.075C15.3529 16.1868 15.18 16.2494 15 16.25C14.8188 16.2502 14.6445 16.1876 14.5131 16.075L14.5008 16.0639L11.0818 12.9815C10.9034 12.8207 10.8338 12.5863 10.8991 12.3666C10.9644 12.147 11.1547 11.9754 11.3983 11.9165C11.642 11.8576 11.902 11.9204 12.0803 12.0813L14.2943 14.0789V8.63621ZM19.7616 16.2047C19.7616 15.8155 20.0388 15.5 20.3808 15.5C20.7228 15.5 21 15.8155 21 16.2047V18.6359C21 19.8035 20.1683 20.75 19.1424 20.75H10.8576C9.83167 20.75 9 19.8035 9 18.6359V16.2047C9 15.8155 9.27722 15.5 9.6192 15.5C9.96117 15.5 10.2384 15.8155 10.2384 16.2047V18.6359C10.2384 19.0251 10.5156 19.3406 10.8576 19.3406H19.1424C19.4844 19.3406 19.7616 19.0251 19.7616 18.6359V16.2047Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/downloadLogo.cb28785b6d00c21cda03ac475e4c318f.svg";